
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.854 22.558L2.146 1.784l18.476-.34 1.642.68.41 17.369-.82 3.065z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.98 22.557l2.841-.343L2.18 1.786l-.443 1.019V21.876l.82.681H18.98z","fill":"#389CD8"}}),_c('path',{attrs:{"d":"M20.822 1H3.178C1.978 1 1 1.81 1 2.806v18.388C1 22.189 1.977 23 3.178 23h17.644c1.2 0 2.178-.81 2.178-1.806V2.806C23 1.811 22.023 1 20.822 1zm1.117 20c0 .51-.503 1-1.117 1H3.178c-.615 0-1.117-.49-1.117-1V3c0-.51.502-1 1.117-1h17.644c.614 0 1.117.49 1.117 1v18z","fill":"#000"}})])
          )
        }
      }
    